import type { Module } from 'vuex'
import type { CustomCalendarEntry, CustomCalendarEntryState } from './types'
import { customCalendarEntryActions } from './actions'
import { clone } from '@/utils/helpers/'
import type { RootState } from '@/store/modules/types'

export const initialCustomCalendarEntryState = (): CustomCalendarEntryState => ({
  entries: [],
  isFetching: false,
  isCreating: false,
  isDeleting: false,
})

const customCalendarEntryModule: Module<CustomCalendarEntryState, RootState> = {
  namespaced: true,
  state: initialCustomCalendarEntryState,
  actions: customCalendarEntryActions,
  mutations: {
    SET_ENTRIES(state, entries: CustomCalendarEntry[]) {
      state.entries = clone(entries)
    },
    ADD_ENTRY(state, entry: CustomCalendarEntry) {
      state.entries = clone([...state.entries, entry])
    },
    REPLACE_ENTRY(state, entry: CustomCalendarEntry) {
      state.entries = clone(state.entries.map(e => e.oid === entry.oid ? entry : e))
    },
    REMOVE_ENTRY(state, oid: number) {
      state.entries = clone(state.entries.filter(e => e.oid !== oid))
    },
    SET_IS_FETCHING(state, val: boolean) {
      state.isFetching = val
    },
    SET_IS_CREATING(state, val: boolean) {
      state.isCreating = val
    },
    SET_IS_DELETING(state, val: boolean) {
      state.isDeleting = val
    },
  },
}

export default customCalendarEntryModule
